import React from 'react';
import { useSelector } from 'react-redux';
import {
  documentsGridLoaderSelector,
  loadedSelector,
  processingDocsCountSelector,
  documentsCurrentCountSelector,
} from 'domain/documents';
import { loadingSelector } from 'domain/env';
import * as ACL from 'domain/restriction';
import { useWorkspaceEmptyState } from 'pages/company/WorkspaceRoute/hooks/useWorkspaceEmptyState';

import NoResult from 'pages/common/empty/noResult';
import NoDocuments from 'pages/common/empty/noDocuments';

const STUB_VIEWS = {
  noDocs: 'noDocs',
  notPresent: 'notPresent',
  notFound: 'notFound',
};

const mapStateToProps = (state) => ({
  isGranted: ACL.isGranted(state),
  companyTotalDocs: documentsCurrentCountSelector(state),
  loading: loadingSelector(state),
  gridLoading: documentsGridLoaderSelector(state),
  processing: processingDocsCountSelector(state),
  docsLoaded: loadedSelector(state),
});

const StubWhenEmpty = () => {
  const { isGranted, companyTotalDocs, loading, gridLoading, processing, docsLoaded } = useSelector(mapStateToProps);
  // DA-19732: the empty view answers one question — is anything being hidden from the user here?
  // The category's own document count answers it: it is taken without the doctype tab, without the
  // sub-type and without the grid column filters, so a non-zero count means the category holds
  // documents that some narrowing hid — the no-results view, with its reset. Zero means nothing is
  // hidden: the category is finished, and the celebration screen with its way on to All is the
  // honest view. The global query is the one narrowing that DOES feed that count, so under it a zero
  // proves nothing and the no-results view is forced.
  // Rule for any narrowing added later: it belongs in the guard next to `hasQuery` only if it
  // reaches the getWorkspaceCategories request; if it does not, the count already accounts for it.
  // The processing gate below stays keyed on the URL query alone (unchanged behaviour: uploads in
  // flight suppress the stub entirely).
  const { hasQuery, categoryHasDocs } = useWorkspaceEmptyState();
  const noDocView = isGranted(ACL.IS_ACCOUNT) ? STUB_VIEWS.noDocs : STUB_VIEWS.notPresent;
  const withoutDocs = companyTotalDocs ? noDocView : STUB_VIEWS.notPresent;
  const noDocs = hasQuery || categoryHasDocs ? STUB_VIEWS.notFound : withoutDocs;

  const view = loading || gridLoading || !docsLoaded || (processing && !hasQuery) ? null : noDocs;

  return view ? (
    <>
      {view === STUB_VIEWS.notFound && <NoResult />}
      {[STUB_VIEWS.noDocs, STUB_VIEWS.notPresent].includes(view) && <NoDocuments view={view} />}
    </>
  ) : null;
};

export default StubWhenEmpty;
